import ToggleFilter from '../../../components/Filters/ToggleFilter';
import { FilterProps } from './FilterProps';
import { useTranslation } from 'react-i18next';

const DigitalTerminalFilter = ({ onChange }: FilterProps) => {
    const { t } = useTranslation();
    return (
        <ToggleFilter
            name="initiating_system.dintero_system_plugin_name"
            label={t('payments.filter.digital_terminal.label')}
            onApply={() => {
                onChange({
                    'initiating_system.dintero_system_plugin_name': ['backoffice-digital-terminal-v1', 'backoffice-digital-terminal-v2'],
                });
            }}
            onDelete={() => {
                onChange({
                    'initiating_system.dintero_system_plugin_name': [],
                });
            }}
        />
    );
};

export default DigitalTerminalFilter;
